import { FC } from "react";

type TAppDropdownMenuItem = {
  title: string;
  red?: boolean;
  onClick: () => void;
};

const AppDropdownMenuItem: FC<TAppDropdownMenuItem> = ({ title, red = false, onClick }) => {
  return (
    <button
      type="button"
      className={`block text-left rounded-lg px-4 py-2 text-sm cursor-pointer ${red
        ? 'text-field-error-dark hover:bg-field-error-dark/15'
        : 'text-gray-500 hover:bg-gray-200 hover:text-gray-700'
        }`}
      role="menuitem"
      onClick={onClick}
    >
      {title}
    </button>
  );
}

type TAppDropdownMenuProps = {
  classPositioningTop?: string;
  classPositioningHorizontal?: string;
  classMarginTop?: string;
  classWidth?: string;
  dividers?: boolean;
  items?: TAppDropdownMenuItem[];
  itemsDivided?: TAppDropdownMenuItem[][];
  show: boolean;
};

const AppDropdownMenu: FC<TAppDropdownMenuProps> = ({
  classPositioningTop = 'top-full',
  classPositioningHorizontal = 'end-0',
  classMarginTop = 'mt-2',
  classWidth = 'w-56',
  dividers = false,
  items,
  itemsDivided,
  show,
}) => {
  return (
    <div
      className={`absolute ${classPositioningTop} ${classPositioningHorizontal} ${classMarginTop} z-10 ${classWidth}${dividers ? ' divide-y divide-gray-100' : ''} rounded-md border border-gray-100 bg-white shadow-lg z-modal${show ? '' : ' hidden'}`}
      role="menu"
    >
      {dividers ? (
        <>
          {itemsDivided?.map((items, index) => (
            <div className="flex flex-col p-2" key={index}>
              {items.map((item, i) => (
                <AppDropdownMenuItem
                  title={item.title}
                  red={item.red}
                  onClick={item.onClick}
                  key={i}
                />
              ))}
            </div>
          ))}
        </>
      ) : (
        <div className="flex flex-col p-2">
          {items?.map((item, i) => (
            <AppDropdownMenuItem
              title={item.title}
              red={item.red}
              onClick={item.onClick}
              key={i}
            />
          ))}
        </div>
      )}
    </div>
  );
}
export default AppDropdownMenu;